// Convert a number to a string with commas
export function numberWithCommas(x: number | string, fixedDecimals?: boolean) {
  const num = Number(x)
  // toFixed rounds instead of truncating, so e.g. 1.1399999856948853
  // renders as 1.14 rather than being cut down to 1.13.
  const [integerPart, decimalPart] = num.toFixed(2).split('.')
  const withCommas = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  if (!Number.isInteger(num) || fixedDecimals) {
    return `${withCommas}.${decimalPart}`
  }
  return withCommas
}

export function generateRandomInteger(max: number) {
  return Math.floor(Math.random() * max) + 1
}

export function clamp(num: number, max: number) {
  return num > max ? max : num
}

export function generateRandomNumber(min: number, max: number) {
  const difference = max - min

  // generate random number
  let rand = Math.random()

  // multiply with difference
  rand = rand * difference

  // add with min value
  rand = rand + min

  return rand
}

export function formatShortAmount(amount: number | string): string {
  const num = typeof amount === "string" ? parseFloat(amount) : amount

  if (isNaN(num)) return '0'

  if (num >= 1_000_000) {
    const value = num / 1_000_000
    const truncated = Math.floor(value * 10) / 10 // truncate to 1 decimal
    return `${Number.isInteger(truncated) ? truncated.toFixed(0) : truncated}M`
  }

  if (num >= 1_000) {
    const value = num / 1_000
    const truncated = Math.floor(value * 10) / 10 // truncate to 1 decimal
    return `${Number.isInteger(truncated) ? truncated.toFixed(0) : truncated}K`
  }

  return num.toString()
}
